<div class="container-fluid">
  <form [formGroup]="notificationCenterForm" class="notification-center">
    <div class="row">
      <h3 class="notification-center-header">Notification Center</h3>
      <hr class="no-margin" />
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-10">
            <div class="label-input-group">
              <div>
                <label>Notification Title</label>
              </div>
              <div>
                <input
                  class="form-control"
                  formControlName="title"
                  type="text"
                />
              </div>
            </div>
          </div>
          <div class="col-md-2 send-button-div">
            <button
              class="btn btn-primary send-button"
              (click)="sendNotification()"
            >
              {{ notificationCenterForm.get('id')!.value ? 'Update' : 'Send' }}
            </button>
          </div>

          <div class="col-md-12">
            <div class="label-input-group">
              <div>
                <label>Notification Text</label>
              </div>
              <div>
                <textarea
                  class="form-control"
                  formControlName="bodyText"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div><label>Start Date</label></div>
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                placeholder="mm/dd/yyyy"
                formControlName="startDate"
                ngbDatepicker
                container="body"
                #startDatePicker="ngbDatepicker"
                appNgbDateInputMask
              />
              <div class="input-group-append">
                <button
                  class="btn btn-primary btn-outline-secondary bi bi-calendar"
                  (click)="startDatePicker.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div><label>End Date</label></div>
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                placeholder="mm/dd/yyyy"
                formControlName="endDate"
                ngbDatepicker
                container="body"
                #endDatePicker="ngbDatepicker"
                appNgbDateInputMask
              />
              <div class="input-group-append">
                <button
                  class="btn btn-primary btn-outline-secondary bi bi-calendar"
                  (click)="endDatePicker.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12 g-0">
                <label>Send To</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-check">
                <label class="form-check-label">All Users</label>
                <input
                  type="checkbox"
                  class="form-check-input"
                  (change)="onAllUsersChange()"
                  formControlName="isAllUsers"
                />
              </div>
              <div class="col-md-6 form-check">
                <label class="form-check-label">Clients</label>
                <input
                  type="checkbox"
                  [(ngModel)]="checkboxModel.clientsGridCheckbox"
                  [ngModelOptions]="{ standalone: true }"
                  name="clientsGridCheckbox"
                  class="form-check-input"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-check">
                <label class="form-check-label">Vendors</label>
                <input
                  type="checkbox"
                  [(ngModel)]="checkboxModel.vendorsGridCheckbox"
                  [ngModelOptions]="{ standalone: true }"
                  name="vendorsGridCheckbox"
                  class="form-check-input"
                />
              </div>
              <div class="col-md-6 form-check">
                <label class="form-check-label">Users</label>
                <input
                  type="checkbox"
                  [(ngModel)]="checkboxModel.usersGridCheckbox"
                  [ngModelOptions]="{ standalone: true }"
                  name="usersGridCheckbox"
                  class="form-check-input"
                />
              </div>
            </div>
          </div>

          @if (notificationCenterForm.get('id')!.value) {
            <div class="col-md-2">
              <button
                class="btn btn-danger"
                (click)="
                  archiveNotification(notificationCenterForm.getRawValue())
                "
              >
                Archive
              </button>
            </div>
          }
        </div>
        <div class="row">
          @if (checkboxModel.clientsGridCheckbox) {
            <app-clients-grid
              [gridName]="'NotificationClientsGrid'"
              [rowSelectionType]="'multiple'"
              [useCheckboxColumn]="true"
              [selectedRowsPrimaryKeys]="selectedIdMap['CompanyId']"
              (selectionChanged)="clientGridSelectionChanged($event)"
            ></app-clients-grid>
          }
        </div>
        <div class="row">
          @if (checkboxModel.vendorsGridCheckbox) {
            <app-vendors-grid
              [gridName]="'NotificationVendorsGrid'"
              [rowSelectionType]="'multiple'"
              [useCheckboxColumn]="true"
              [selectedRowsPrimaryKeys]="selectedIdMap['VendorId']"
              (selectionChanged)="vendorGridSelectionChanged($event)"
            ></app-vendors-grid>
          }
        </div>
        <div class="row">
          @if (checkboxModel.usersGridCheckbox) {
            <app-users-grid
              [gridName]="'NotificationUsersGrid'"
              [rowSelectionType]="'multiple'"
              [useCheckboxColumn]="true"
              [selectedRowsPrimaryKeys]="selectedIdMap['UserId']"
              (selectionChanged)="userGridSelectionChanged($event)"
            ></app-users-grid>
          }
        </div>
      </div>
      <div class="col-md-4 no-right-padding no-left-padding card-column-parent">
        <!--Here we'll put a list of all active alerts-->
        <app-card-column
          [enableSelection]="true"
          [borderClassArray]="['column-border-left']"
          (cardClick)="cardClicked($event)"
          [cardCollection]="notificationCardCollection"
        ></app-card-column>
      </div>
    </div>
  </form>
</div>
